import { Component, OnInit, ElementRef, Injector, Input, ChangeDetectionStrategy } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

/**
 * Component wrapper for FilesController
 */
@Component({
  selector: 'files-list',
  template: '<files-list-directive [user]="user"></files-list-directive>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class FilesListComponent implements OnInit {
  @Input() user: string;

  constructor() {}

  ngOnInit() {
    // No specific route params needed for files component
  }
}

/**
 * Directive for downgrading FilesListComponent
 */
@Component({
  selector: 'files-list-directive',
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class FilesListDirective extends UpgradeComponent {
  @Input() user: string;

  constructor(elementRef: ElementRef, injector: Injector) {
    super('files', elementRef, injector);
  }
}
